import { BlockProps } from '@features/main-page-builder/model/blockRegistry'

export default function PersonalizedProductsBlock ({
  payload
}: BlockProps) {
  // TODO: Implement personalized products block
  // This should render personalized product recommendations
  
  return (
    <div>
      <h3>Personalized Products Block</h3>
      <p>Payload: {JSON.stringify(payload)}</p>
      {/* Add PersonalizedProductCarousel */}
    </div>
  )
}